import { useState } from "react";
import { Link } from "react-router-dom";
import { adminApi } from "@/lib/adminApi";
import { toast } from "sonner";
import { Mail, Loader2 } from "lucide-react";

export default function AdminForgot() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adminApi.post("/auth/forgot", { email });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0b1220] text-slate-100 flex items-center justify-center px-6" data-testid="admin-forgot-page">
      <div className="w-full max-w-md">
        <div className="bg-[#0f172a] border border-slate-800 rounded-xl p-8 shadow-2xl">
          <h1 className="text-2xl font-semibold mb-2">Mot de passe oublié</h1>
          <p className="text-sm text-slate-400 mb-6">Recevez un lien de réinitialisation par e-mail.</p>
          {sent ? (
            <div className="p-4 rounded-md bg-emerald-500/10 border border-emerald-500/30 text-emerald-300 text-sm flex items-start gap-3" data-testid="admin-forgot-sent">
              <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" />
              <p>Si un compte administrateur existe pour cet e-mail, un lien de réinitialisation vient d'être envoyé. Vérifiez votre boîte de réception.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-forgot-email"
                className="w-full bg-[#0b1220] border border-slate-700 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:border-emerald-500/50"
                placeholder="votre-email@exemple.com"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="admin-forgot-submit"
                className="w-full bg-emerald-600 hover:bg-emerald-500 disabled:opacity-50 text-white font-medium py-2.5 rounded-md text-sm inline-flex items-center justify-center gap-2"
              >
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
                Envoyer le lien
              </button>
            </form>
          )}
          <div className="mt-6 text-center">
            <Link to="/admin/login" className="text-xs text-slate-500 hover:text-emerald-400" data-testid="admin-forgot-back">Retour à la connexion</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
